import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { Box, Container, Typography, Paper, Link } from '@mui/material';
import { useSnackbar } from 'notistack';
import { FormikTextField } from '../components/FormikTextField';
import { FormikSubmitButton } from '../components/FormikSubmitButton';
import { useForgotPasswordMutation } from '../services/authApi';
import { Link as RouterLink } from 'react-router-dom';

const validationSchema = yup.object({
    email: yup.string().email('Enter a valid email').required('Email is required'),
});

const ForgotPassword = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [forgotPassword] = useForgotPasswordMutation();

    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        padding: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <Typography component="h1" variant="h5" gutterBottom>
                        Forgot Password
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                        Enter your email address and we'll reach out to you.
                    </Typography>

                    <Formik
                        initialValues={{
                            email: '',
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                await forgotPassword(values).unwrap();
                                enqueueSnackbar('Password reset instructions have been sent to your email.', { variant: 'success' });
                                // Optional: navigate to login or show success state
                            } catch (error: any) {
                                const errorMessage = error?.data?.message || 'An error occurred';
                                enqueueSnackbar(errorMessage, { variant: 'error' });
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                    >
                        <Form style={{ width: '100%' }}>
                            <FormikTextField
                                name="email"
                                margin="normal"
                                label="Email Address"
                                autoComplete="email"
                                autoFocus
                            />
                            <FormikSubmitButton
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                                loadingText="Sending..."
                            >
                                Send Reset Link
                            </FormikSubmitButton>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Link component={RouterLink} to="/login" variant="body2">
                                    Back to Sign In
                                </Link>
                            </Box>
                        </Form>
                    </Formik>
                </Paper>
            </Box>
        </Container>
    );
};

export default ForgotPassword;
